import { useState, useEffect } from 'react';

type WindowSize = {
  width: number | null;
  height: number | null;
};

function useWindowSize(): WindowSize {
  const [size, setSize] = useState<WindowSize>({
    width: null,
    height: null,
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return size;
}

export default useWindowSize;
